module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 15